<!--one3d-extended-warranty-wrapper starts here-->
<configurator-header></configurator-header>

<ion-content scrollY="false" class="one3d-extended-warranty-wrapper">
  <div class="one3d-summary-wrapper">
    <div class="one3d-content-header one3d-custom-border-bottom">
      <h1 class="one3d-content-header-title" translate>EXTENDED_WARRANTY.EXTENDED_WARRANTY</h1>
      <button (click)="closeWarranty()">
        <span
          ><img
            src="assets/img/icons/one3d-close-icon.svg"
            alt="close page icon"
        /></span>
      </button>
    </div>
    <div class="one3d-scrollable-wrapper-custom">
      <!-- <div
        class="one3d-summary-ext-int-wrapper one3d-custom-border-bottom one3d-summary-row-margin"
      >
        <div class="one3d-summary-ext-int one3d-summary-ext one3d-mb-0">
          <ion-row>
            <ion-col size="6">
              <span class="one3d-summary-item-name">
                <strong> VEHICLE PURCHASE DATE </strong> (As per RC book)
              </span>
            </ion-col>
            <ion-col size="6">
              <div class="one3d-summary-content-right-col">
                <span
                  class="one3d-summary-item-value extended-warranty-date-field-box"
                > -->
      <!-- <span class="one3d-extended-warranty-input"> -->
      <!-- <input
                    type="date"
                    mode="md"
                    id="purchaseDate"
                    placeholder="Select Date"
                    onkeydown="return false"
                    [(ngModel)]="purchaseDate"
                    class="one3d-extended-warranty-input-field"
                    min="{{ minValueDate }}"
                    max="{{ maxValueDate }}"
                    (change)="dateChange()"
                  />
                  <span class="one3d-new-calendar-icon">
                    <img src="assets/img/icons/one3d-calendar-icon.svg" />
                  </span>  -->
      <!-- <span class="one3d-extended-warranty-input-icon">
                      <img
                        src="assets/img/icons/one3d-calendar-icon.svg"
                        alt="calendar icon"
                      />
                    </span> -->
      <!-- </span> -->
      <!-- <ion-datetime class="one3d-extended-warranty-calendar">
                  </ion-datetime> -->
      <!-- </span>
              </div>
            </ion-col>
          </ion-row>
        </div>
      </div> -->

      <!-- <div *ngIf="isDateSelected"
        class="one3d-summary-ext-int-wrapper one3d-custom-border-bottom one3d-summary-row-margin">
        <div class="one3d-summary-ext-int one3d-summary-ext one3d-mb-0">
          <ion-row>
            <ion-col size="6">
              <span class="one3d-summary-item-name">
                <strong> VEHICLE AGE </strong>
              </span>
            </ion-col>
            <ion-col size="6">
              <div class="one3d-summary-content-right-col">
                <span class="one3d-summary-item-name">
                  {{ vehicleAge }} Days Old
                </span>
              </div>
            </ion-col>
          </ion-row>
        </div>
      </div> -->

      <div
        *ngIf="isDateSelected"
        class="one3d-summary-ext-int-wrapper one3d-custom-border-bottom one3d-summary-row-margin"
      >
        <div class="one3d-summary-ext-int one3d-summary-ext one3d-mb-0">
          <ion-row>
            <ion-col size="6">
              <span class="one3d-summary-item-name">
                <strong translate>EXTENDED_WARRANTY.DURATION</strong>
              </span>
            </ion-col>
            <ion-col size="6">
              <div class="one3d-summary-content-right-col">
                <span class="one3d-summary-item-name">
                  {{ allOptionCategory[0].product_year }}
                </span>
              </div>
            </ion-col>
          </ion-row>
        </div>
      </div>

      <div
        *ngIf="isDateSelected"
        class="one3d-summary-ext-int-wrapper one3d-custom-border-bottom one3d-summary-row-margin"
      >
        <div class="one3d-summary-ext-int one3d-summary-ext one3d-mb-0">
          <ion-row>
            <ion-col size="12">
              <span class="one3d-summary-item-name">
                <strong translate>EXTENDED_WARRANTY.SELECT_MILEAGE </strong>
              </span>
              <div class="one3d-kilometers-driven-wrap">
                <ion-list>
                  <!-- <ion-radio-group>
                    <ion-item *ngFor="let item of allOptionCategory" lines="none">
                      <ion-radio value="{{item.optionCategory}}" checked="false" (click)="selectDrivenCategory(item.optionsList)"></ion-radio>
                      <ion-label>{{item.optionCategory}}</ion-label>
                    </ion-item>
                  </ion-radio-group> -->
                  <ion-item
                    lines="none"
                    *ngFor="let item of allOptionCategory"
                    (click)="selectDrivenCategory(item.optionsList)"
                    class="extended-warranty-radio"
                  >
                    <input
                      type="radio"
                      style="pointer-events: none"
                      [checked]="
                        item.optionsList[0]?.warranty_price ==
                          kmsDrivenOption?.warranty_price && isKmsDrivenSelected
                      "
                    />
                    <ion-label>{{ item.optionsList[0].product_kms }}</ion-label>
                  </ion-item>
                </ion-list>
              </div>
            </ion-col>
          </ion-row>
        </div>
      </div>

      <div
        *ngIf="isKmsDrivenSelected"
        class="one3d-summary-ext-int-wrapper one3d-custom-border-bottom one3d-summary-row-margin"
      >
        <div class="one3d-summary-ext-int one3d-summary-ext one3d-mb-0">
          <ion-row>
            <ion-col size="6">
              <span class="one3d-summary-item-name">
                <strong translate> EXTENDED_WARRANTY.WARRANTY_COST </strong>
              </span>
            </ion-col>
            <ion-col size="6">
              <div class="one3d-summary-content-right-col">
                <span class="one3d-summary-item-name">
                  <strong>
                     {{ globalService.currencyFormatter(warrantyPrice) }}
                  </strong>
                </span>
              </div>
            </ion-col>
          </ion-row>
        </div>
      </div>
    </div>
  </div>
  <!--extended-warranty-disclaimer-wrapper starts here-->
  <div class="extended-warranty-disclaimer-wrapper">
    <div class="extended-warranty-disclaimer-in ion-text-right">
      <!-- <span class="extended-warranty-disclaimer-text">
        <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M4.99984 0.833415C2.69865 0.833415 0.833171 2.69889 0.833171 5.00008C0.833171 7.30127 2.69865 9.16675 4.99984 9.16675C7.30102 9.16675 9.1665 7.30127 9.1665 5.00008C9.1665 2.69889 7.30102 0.833415 4.99984 0.833415Z" stroke="black" stroke-width="0.833333" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M5 6.66675V5.00008" stroke="black" stroke-width="0.833333" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M5 3.33325H4.995" stroke="black" stroke-width="0.833333" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <ion-text > Disclaimer </ion-text>
      </span> -->
      <div class="extended-warranty-disclaimer-tooltip ion-text-left">
        <h4 translate>EXTENDED_WARRANTY.DISCLAIMER</h4>
        <ion-text translate>
          EXTENDED_WARRANTY.DISCLAIMER_NOTE 
        </ion-text>
      </div>
    </div>
  </div>
  <!--extended-warranty-disclaimer-wrapper ends here-->

  <div class="one3d-lhs-config-bottom-wrapper one3d-placeAtBottom-summary">
    <ion-row class="one3d-lhs-config-btn-row">
      <ion-col class="ion-no-padding" size="6">
        <ion-button
          (click)="skipWarranty()"
          class="one3d-lhs-config-btn one3d-lhs-config-left-btn"
          expand="full"
          fill="solid"

          translate
        >
        EXTENDED_WARRANTY.SKIP
          <!-- <span>
            <ion-icon name="chevron-forward-outline"></ion-icon>
          </span> -->
        </ion-button>
      </ion-col>
      <ion-col class="ion-no-padding" size="6">
        <ion-button
          (click)="addToSummary()"
          [disabled]="!isKmsDrivenSelected"
          class="one3d-lhs-config-btn one3d-lhs-config-right-btn"
          expand="full"

          translate
        >
        EXTENDED_WARRANTY.ADD_TO_SUMMARY
          <!-- <span>
            <ion-icon name="chevron-forward-outline"></ion-icon>
          </span> -->
        </ion-button>
      </ion-col>
    </ion-row>
  </div>
</ion-content>
<!--one3d-extended-warranty-wrapper ends here-->
